export default 'codesquareo';
